export default "__VITE_ASSET__540cf3e6__"